module.exports = __webpack_public_path__ + "img/layout_ladder.ff63f327.svg";